import { useContext } from 'react';

import calcBaseUrl from './calcBaseUrl';
import ParamsContext from './ParamsContext';


/**
 * Описание в файле withRouterParams
 */

const useRouterParams = () => useContext(ParamsContext);

type Except = Array<string>;

export const useRouterParamsE = (except: Except) => {
  const context = useContext(ParamsContext);
  const baseUrl = calcBaseUrl(context, except);
  return {
    ...context,
    baseUrl,
  };
};

export default useRouterParams;
